export default "__VITE_ASSET__CQIOkwWH__"